import { WidgetType } from '../enums/widget-type.enum';
import type { IAnswer } from '../interfaces/answer.interface';

const conversationWidgetTypes = new Set<WidgetType>([
  WidgetType.chat,
  WidgetType.cb,
  WidgetType.cip,
  WidgetType.ce,
  WidgetType.cmt,
  WidgetType.ctt,
]);

export const isConversationWidget = (widgetType: WidgetType): boolean =>
  conversationWidgetTypes.has(widgetType);

export const getLatestRateableQuestionId = (
  conversationResults: readonly IAnswer[]
): string | null => {
  for (let index = conversationResults.length - 1; index >= 0; index--) {
    const turn = conversationResults[index];
    const questionId = turn?.question_id?.trim();

    if (
      questionId &&
      !turn.is_greeting &&
      !turn.is_streaming &&
      !turn.is_streamCancelled &&
      !turn.hideOnChat
    ) {
      return questionId;
    }
  }

  return null;
};

export const resolveRateableQuestionId = (
  widgetType: WidgetType,
  conversationResults: readonly IAnswer[],
  searchResult: IAnswer | null
): string | null => {
  if (isConversationWidget(widgetType)) {
    return getLatestRateableQuestionId(conversationResults);
  }

  return searchResult?.question_id?.trim() || null;
};
